/* eslint-disable max-len */
import React, { useRef, useState } from 'react'
import InputField from '../../../../../components/InputFeld'
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import GroupsDropDown from './GroupsDropDown';

export default function AddGroups({
    recodes,
    exitVal,
    handleOnchangeInput,
    handelCheckboxType,
    getListOfGroup,
    setSearchValue,
    loadingSearch,
    groupList,
    setSelectedGroupType,
    setIsSchemeGroup,
    searchValue,
    selectedGroupType,
    isAlreadyExit,
    descriptionLength
}) {
    const outsideClickRef = useRef();
    const [isSelectDropdown, setIsSelectDropdown] = useState(false);
    const openingBalanceRef = useRef();
    const [isOpeningBalance, setIsOpeningBalance] = useState(false)
    const sheetType = ["PL", "BS"];
    const openingBalanceType = ["Debit", "Credit"]

    /* The above code is using the `useOnClickOutside` hook to handle a click event outside of a
    specific element referenced by `outsideClickRef`. When the click event occurs outside of the
    element, it sets the state variable `isSelectDropdown` to `false`. */
    useOnClickOutside(outsideClickRef, () => {
        setIsSelectDropdown(false);
    });

    /* The above code is using a custom hook called `useOnClickOutside` in a React component. This hook
    takes two arguments: `openingBalanceRef`, which is a reference to a DOM element, and a callback
    function. */
    useOnClickOutside(openingBalanceRef, () => {
        setIsOpeningBalance(false);
    });

    return (
        <>
            <div class="xl:w-[70%] 2xl:w-[78%] mx-auto mt-3">
                <div class="border border-[#D0D5DD] p-3 rounded">
                    <div class="flex -mx-[19px]">
                        <div class="w-1/2 pl-[20px] pr-[24px]">
                            <div class="flex items-center w-full mb-4">
                                <label for="empNumber" class="text-f7 font-normal text-[#031624] min-w-[120px] inline-flex">{recodes.type === "group" ? "Group Name" : "Ledger Name"}<span class="req-fld-astrk">*</span></label>
                                {/* <input type="text" id="empNumber" class="border border-[#D0D5DD] rounded w-full px-3.5 py-1.5 text-f7 font-normal text-[#031624] placeholder:text-f7 placeholder:text-normal placeholder:text-[#818E98] outline-0 error_border" placeholder="Enter Group Name"/> */}
                                <InputField
                                    inputId={recodes.type === "group" ? "group_name" : "ledger_name"}
                                    inputLabel={recodes.type === "group" ? "Group Name" : "Leger Name"}
                                    inputType={"text"}
                                    inputPlaceholder={recodes.type === "group" ? "Enter Group Name" : "Enter Ledger Name"}
                                    inputDisabled={false}
                                    isMandatoryField={true}
                                    inputErrorMessage={(((recodes.ledger_name === "" && recodes.group_name === "" ) && exitVal) || isAlreadyExit) ? "Name is Mandatory" : ""}
                                    inputMaxLength={30}
                                    inputValue={recodes.type === "group" ? recodes.group_name : recodes.ledger_name}
                                    inputChange={handleOnchangeInput}
                                />
                            </div>
                            <div class="flex w-full">
                                <div class="flex items-center w-full mb-4">
                                    <label for="bname" class="text-f7 font-normal text-[#031624] min-w-[120px] inline-flex">{recodes.type === "group" ?  "Parent Group" : "Group"}<span class="req-fld-astrk">*</span></label>
                                    <GroupsDropDown
                                        outsideClickRef={outsideClickRef}
                                        exitVal={exitVal}
                                        setSearchValue={setSearchValue}
                                        getListOfGroup={getListOfGroup}
                                        setIsSelectDropdown={setIsSelectDropdown}
                                        isSelectDropdown={isSelectDropdown}
                                        recodes={recodes}
                                        loadingSearch={loadingSearch}
                                        groupList={groupList}
                                        handelCheckboxType={handelCheckboxType}
                                        setSelectedGroupType={setSelectedGroupType}
                                        setIsSchemeGroup={setIsSchemeGroup}
                                        searchValue={searchValue}
                                        selectedGroupType={selectedGroupType}
                                    />
                                </div>
                            </div>
                            <div class="flex items-center w-full">
                                <label for="Description" class="text-f7 font-normal text-[#031624] min-w-[120px] inline-flex self-start pt-2.5">Description</label>
                                <div class={`error_border h-[56px] w-full`}>
                                    <textarea
                                        id="description"
                                        value={recodes.description}
                                        onChange={(e) => handleOnchangeInput(e)}
                                        maxLength={100}
                                        className={`txt-fld w-full ${descriptionLength ? "redBorder" : ""}`}
                                        placeholder="Enter Description"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                        {(recodes.type === 'ledger') && <div class="w-1/2 px-[19px] capital_account_section">
                            <div class="flex items-center w-full mb-4">
                                <label for="openingBalance" class="text-f7 font-normal text-[#031624] min-w-[135px] inline-flex">Opening Balance</label>
                                <div class="relative w-full">
                                    <InputField
                                        inputId={"opening_balance"}
                                        inputLabel={"Enter Amount"}
                                        inputType={"text"}
                                        inputPlaceholder={"Enter Amount"}
                                        inputDisabled={!(recodes.group_type === 'BS')}
                                        isMandatoryField={true}
                                        inputErrorMessage={""}
                                        inputMaxLength={13}
                                        inputValue={isNaN(recodes.opening_balance) ? "" : recodes.opening_balance}
                                        inputChange={handleOnchangeInput}
                                        
                                        
                                    />
                                    {/* <input type="text" id="openingBalance" class="border border-[#D0D5DD] rounded w-full error_border h-9 px-3.5 pl-8 text-base font-normal text-[#031624] placeholder:text-f7 placeholder:text-normal placeholder:text-[#818E98] outline-0 error_border" placeholder="Enter Amount"/> */}
                                    <p alt="icon" class="absolute top-[50%] -translate-y-[50%] left-[13px] text-f7 text-normal text-[#818E98]"> </p>
                                </div>
                            </div>
                            <div class="flex w-full">
                                <div class="flex items-center w-full mb-4">
                                    <label for="bname" class="text-f7 font-normal text-[#031624] min-w-[135px] inline-flex">Debit/Credit</label>
                                    <div class="relative w-full" ref={openingBalanceRef}>
                                        {/* <!-- for disabled bg-[#E6E8EA] --> */}
                                        <button 
                                            class={`${(recodes.opening_balance === null || recodes.opening_balance === "" || isNaN(recodes.opening_balance)) ? "bg-[#E6E8EA] border-[#D0D5DD]" : (recodes.opening_balance_type === "" && exitVal)  ? "redBorder" : ""} slct-inpt-fld transition duration-150 ease-in-out debitNCredit`}
                                            type="button" 
                                            disabled={recodes.opening_balance === null || recodes.opening_balance === "" || isNaN(recodes.opening_balance)}
                                            id="credit_drop" 
                                            onClick={() => {setIsOpeningBalance(!isOpeningBalance)}}
                                        >
                                            <p class={`text-f7 ${ recodes?.opening_balance_type === "" ? "text-[#818E98]" : "text-[#344054] "} font-normal`}>{recodes?.opening_balance_type === "" ? "Select Debit/Credit" : recodes.opening_balance_type}</p>
                                            {/* <p class="text-f7 text-[#818E98] font-normal">Select Debit/Credit</p> */}
                                            <img src="/images/dropdown-icon.png" alt="icon" class={`absolute top-[50%] -translate-y-[50%] dropdown-close right-3 ${isOpeningBalance? "transform rotate-180" : ""}`}/>
                                        </button>
                                        {isOpeningBalance && <ul class="slct_drp_dwn min-w-full [&amp;[data-te-dropdown-show]]:block" aria-labelledby="dropdownMenu_acdemic_year" data-te-dropdown-menu-ref="">
                                            <li class="max-h-[160px] overflow-auto scroll-bar">
                                                <ul>
                                                    {openingBalanceType.map((item) => (
                                                        <li key={item}>
                                                            <p
                                                                class="slct_drp_dwn_optn"
                                                                onClick={() => {handelCheckboxType(item , 'opening_balance_type'); setIsOpeningBalance(false) }}
                                                            >
                                                                {item}
                                                            </p>
                                                        </li>))}
                                                </ul>
                                            </li>
                                        </ul>}
                                    </div>
                                </div>
                            </div>
                        </div>}
                        {recodes.type === 'group' && <div class="w-1/2 px-[19px]">
                            <div class="w-full pt-2">
                                <div class="flex -mx-1">
                                    {sheetType.map((item) => ( 
                                        <div class="w-auto px-1 mr-4" key={item}>
                                            <div class="relative custom-radioBlue mb-4 flex items-center m-auto " >
                                                <input id={item} onChange={() => handelCheckboxType(item, "group_type")}  type="radio" checked={recodes.group_type === item} name="default-radio1"/>
                                                <label for={item} class="text-f7" style={{'font-size':'0.938rem'}}>{item === 'PL' ? "Profit & Loss" : "Balance Sheet"}</label>
                                            </div>
                                        </div>
                                    ))}
                                    
                                </div>
                            </div>
                        </div>}                        
                    </div>
                </div>
            </div>
        </>
    )
}
